import { useFormikContext } from 'formik';
import { get } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type DealerListDataFragment } from '../../../../../../../api/fragments/DealerListData';
import FormFields from '../../../../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../../../../utilities/useSystemSwitchData';
import ColumnOrFragment from './ColumnOrFragment';

export type MarketInputsProps = {
    name: string;
    asFragment?: boolean;
    dealers?: DealerListDataFragment[];
};

const NewZealandMarketInput = ({ name, asFragment, dealers }: MarketInputsProps) => {
    const { t } = useTranslation('moduleDetails');
    const { yesNoSwitch } = useSystemSwitchData();

    const { values } = useFormikContext();

    const isViewable = useMemo(() => get(`${name}.nzFees.viewable`, values), [name, values]);

    return (
        <>
            <ColumnOrFragment asFragment={asFragment} md={8} xs={24}>
                <FormFields.SwitchField
                    {...t('moduleDetails:fields.nzFeesViewable', { returnObjects: true })}
                    name={`${name}.nzFees.viewable`}
                    {...yesNoSwitch}
                />
            </ColumnOrFragment>
            {isViewable && (
                <>
                    <ColumnOrFragment asFragment={asFragment} md={8} xs={24}>
                        <FormFields.SwitchField
                            {...t('moduleDetails:fields.ppsr.ppsrEditable', { returnObjects: true })}
                            name={`${name}.ppsr.editable`}
                            {...yesNoSwitch}
                        />
                    </ColumnOrFragment>
                    <ColumnOrFragment asFragment={asFragment} md={8} xs={24}>
                        <FormFields.SwitchField
                            {...t('moduleDetails:fields.estFee.estFeeEditable', { returnObjects: true })}
                            name={`${name}.estFee.editable`}
                            {...yesNoSwitch}
                        />
                    </ColumnOrFragment>
                    <ColumnOrFragment asFragment={asFragment} md={8} xs={24}>
                        <FormFields.SwitchField
                            {...t('moduleDetails:fields.bankEstFeeEditable', { returnObjects: true })}
                            name={`${name}.bankEstFee.editable`}
                            {...yesNoSwitch}
                        />
                    </ColumnOrFragment>
                </>
            )}
        </>
    );
};

export default NewZealandMarketInput;
